import ReactPaginate from 'react-paginate';

/**
 * Standard 20-per-page pager. Renders nothing when everything fits on one page.
 * onPageChange receives the zero-based page index.
 */
const Pagination = ({ pageCount, currentPage, onPageChange }) => {
	if (!pageCount || pageCount <= 1) return null;

	return (
		<div className='mt-6 flex justify-center'>
			<ReactPaginate
				breakLabel='...'
				nextLabel='next >'
				onPageChange={(event) => onPageChange(event.selected)}
				pageRangeDisplayed={5}
				pageCount={pageCount}
				previousLabel='< previous'
				forcePage={currentPage}
				className='flex items-center space-x-1'
				pageClassName=''
				pageLinkClassName='px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors'
				previousClassName=''
				previousLinkClassName='px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors'
				nextClassName=''
				nextLinkClassName='px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors'
				breakClassName=''
				breakLinkClassName='px-3 py-2 text-sm text-gray-600'
				activeClassName=''
				activeLinkClassName='px-3 py-2 text-sm text-white bg-black font-medium'
				disabledClassName=''
				disabledLinkClassName='px-3 py-2 text-sm text-gray-400 cursor-not-allowed'
			/>
		</div>
	);
};

export default Pagination;
